﻿import { onlyDigits } from "@js/core/utils/text";

export function detectCardType(cardNumber) {
    const digits = onlyDigits(cardNumber);

    if (/^3[47]/.test(digits)) {
        return "amex";
    }

    return "default";
}

export function isValidLuhn(number) {
    const digits = onlyDigits(number);
    if (!digits) return false;

    let sum = 0;
    let shouldDouble = false;

    for (let i = digits.length - 1; i >= 0; i--) {
        let digit = parseInt(digits.charAt(i), 10);

        if (shouldDouble) {
            digit *= 2;
            if (digit > 9) digit -= 9;
        }

        sum += digit;
        shouldDouble = !shouldDouble;
    }

    return (sum % 10) === 0;
}

export function formatExpireDate(value) {
    const digits = onlyDigits(value).substring(0, 4);

    if (digits.length <= 2) return digits;

    return `${digits.substring(0, 2)} / ${digits.substring(2, 4)}`;
}

export function isValidExpireDate(value) {
    const digits = onlyDigits(value);

    if (digits.length !== 4) return false;

    const month = parseInt(digits.substring(0, 2), 10);
    const year = parseInt(digits.substring(2, 4), 10);

    if (Number.isNaN(month) || Number.isNaN(year)) return false;
    if (month < 1 || month > 12) return false;

    const now = new Date();
    const currentYear = now.getFullYear() % 100;
    const currentMonth = now.getMonth() + 1;

    if (year < currentYear) return false;
    if (year === currentYear && month < currentMonth) return false;
    if (year > currentYear + 10) return false;

    return true;
}